// extracted by mini-css-extract-plugin
export var home = "bgour-module--home--3YBGW";
export var header = "bgour-module--header--1XIWH";
export var pstyles = "bgour-module--pstyles--12gci";